import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';
import type { AgentSessionIndexResponse } from '@reflex/shared';

/**
 * The agent's session index (`GET /agents/:id/session-index`): every
 * prompt and turn boundary as small Postgres-backed rows, available
 * before any events load. The nav rail renders whole-session turns from
 * it; `sessionIndexFromSeq` null means the agent has no index (legacy).
 */
export function useAgentSessionIndex(agentId: string | null) {
  return useQuery<AgentSessionIndexResponse>({
    queryKey: [...queryKeys.sessionIndex(agentId ?? '')],
    queryFn: () => api.getSessionIndex(agentId!) as Promise<AgentSessionIndexResponse>,
    enabled: !!agentId,
    // Fresh turns arrive through the live event stream and are represented
    // by the loaded transcript; the index only has to cover history.
    staleTime: 60_000,
  });
}
